import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Grid, Typography } from '@material-ui/core';
import { format } from 'date-fns';
import addDays from 'date-fns/add_days';
import subDays from 'date-fns/sub_days';
import './HomeMobile.css';
import ErrorPopup from './ErrorPopup';
import coachCapIcon from '../assets/baseball-cap-blue.png';
import umpMaskIcon from '../assets/umpire-mask.png';
import umpCapIcon from '../assets/umpire-cap.png';
import cancelledGameIcon from '../assets/cancelled-game.png';
import cheerIcon from '../assets/cheer.png';

class HomeMobile extends Component {

  state = {
    filter: {
      startDate: '',
      value: 7,
      showAllGames: false,
      page: 'home'
    },
    filterType: {
      day: { value: 1, text: 'By Day' }, 
      week: { value: 7, text: 'By Week' }
    },
    selectedSeason: '',
    additionalGamesLoaded: false,
    displayAdditionalGames: false
  };

  componentDidMount() {
    const { userSeason, memberId, getUmpire, updateMobileState, 
      getCoachesTeams, getTeamsVolunteering, getSeasonDivisions } = this.props;

    getUmpire();
    let date = Date.now();
    let today = format(date, 'MM/DD/YYYY');

    let newMobile = {};
    let newDay = today;
    let newFilterValue = 7;
    let toShowAllGames = false;
    if (Object.values(this.props.mobile).length > 0 && this.props.mobile.page) {
      
      if (this.props.mobile.value) {
        newFilterValue = this.props.mobile.value;
      }
      if (this.props.mobile.startDate) {
        newDay = this.props.mobile.startDate;
      }
      if (this.props.mobile.showAllGames) {
        toShowAllGames = this.props.mobile.showAllGames;
      }

      newMobile = { startDate: newDay, filter: newFilterValue, toShowAllGames, page: 'home' };

    } else {
      newMobile = {
        startDate: today,
        value: this.state.filter.value,
        showAllGames: toShowAllGames,
        page: 'home'
      };
      this.loadDefaultGames();
      if (userSeason) {
        getCoachesTeams(memberId, userSeason);
        getTeamsVolunteering(memberId, userSeason);
        getSeasonDivisions(userSeason);getSeasonDivisions();
      };
    }

    updateMobileState(newMobile);

    this.setState({
      filter: {
        startDate: newDay,
        value: newFilterValue, 
        page: 'home',
        showAllGames: toShowAllGames
      } 
    });
  }

  componentDidUpdate(prevProps) {
    const {
      fetchingGamesStatus,
      fetchingSeasonsStatus,
      fetchingFilteredGamesStatus,
      userSeason,
      memberId,
      getCoachesTeams, getTeamsVolunteering, 
      getSeasonDivisions,
      mobile
    } = this.props;
    const {
      displayAdditionalGames,
      additionalGamesLoaded
    } = this.state;

    if (this.props !== prevProps) {
      let umpiresCheck = this.areUmpiresLoaded();
      let seasonsCheck = this.areSeasonsLoaded();
      let defaultGamesCheck = this.defaultGamesLoaded();
      let additionalGamesCheck = additionalGamesLoaded;

      if (!umpiresCheck) umpiresCheck = this.props.umpFetchStatus === 'Loaded';

      if (!seasonsCheck)
        seasonsCheck = fetchingSeasonsStatus === 'Loaded';

      if (!defaultGamesCheck) {
        defaultGamesCheck = fetchingGamesStatus === 'Loaded';
        if (
          fetchingFilteredGamesStatus !== 'Loading' &&
          fetchingFilteredGamesStatus !== 'Error' &&
          fetchingFilteredGamesStatus !== 'Loaded'         ) {
          this.loadDefaultGames();
          if (userSeason) {
            getCoachesTeams(memberId, userSeason);
            getTeamsVolunteering(memberId, userSeason);
            getSeasonDivisions(userSeason);getSeasonDivisions();
          }
        }
      }

      additionalGamesCheck =
        this.areSeasonsLoaded() &&
        displayAdditionalGames &&
        (fetchingGamesStatus === 'Loaded' || fetchingGamesStatus === 'Loaded');

      if(userSeason && userSeason !== prevProps.userSeason){
        this.updateDefaultGames(userSeason);
        getCoachesTeams(memberId, userSeason);
        getSeasonDivisions(userSeason);
      }

      let newFilter = this.state.filter;
      if(mobile.page === 'home'){
        newFilter = mobile; 
      }
      
      this.setState({
        ...this.state,
        filter: newFilter, 
        additionalGamesLoaded: additionalGamesCheck,
      });
    }
  }

  isAdmin = () => {
    return this.props.userType === 'Admin';
  }

  isUmpire = () => {
    return this.props.umpireLevel !== null && this.props.umpireLevel > 0;
  }

  isCoach = () => {
    return this.props.teamsCoaching.length > 0;
  }

  defaultGamesLoaded = () => {
    const { fetchingGamesStatus } = this.props;
    return fetchingGamesStatus === 'Loaded' || fetchingGamesStatus === 'Error';
  }

  filterGamesLoaded = () => {
    const { fetchingFilteredGamesStatus } = this.props;
    return fetchingFilteredGamesStatus === 'Loaded' || fetchingFilteredGamesStatus === 'Error';
  }

  areSeasonsLoaded = () => {
    const { fetchingSeasonsStatus } = this.props;
    return fetchingSeasonsStatus === 'Loaded' || fetchingSeasonsStatus === 'Error';
  }

  areUmpiresLoaded = () => {
    const { umpFetchStatus } = this.props;
    return umpFetchStatus === 'Loaded' || umpFetchStatus === 'Error';
  }

  teamsCoachingLoaded = () => {
    const { fetchingCoachTeamsStatus } = this.props;
    return fetchingCoachTeamsStatus === 'Loaded' || fetchingCoachTeamsStatus === 'Error';
  }

  handleAddDate = e => {
    e.preventDefault();
    const { startDate, value, showAllGames } = this.state.filter;
    const newSelectedDate = format(addDays(startDate, value === 7 ? 8 : 1), 'MM/DD/YYYY');
    this.loadDefaultGamesFromDates(newSelectedDate, value);

    this.props.updateMobileState({
      startDate: newSelectedDate,
      value: value,
      page: 'home',
      showAllGames: showAllGames
    });

    this.setState({
      ...this.state,
      defaultGamesLoaded: false,
      displayAdditionalGames: false
    });
  };

  handleSubtractDate = e => {
    e.preventDefault();
    const { startDate, value, showAllGames } = this.state.filter;
    const newSelectedDate = format(subDays(startDate, value === 7 ? 8 : 1), 'MM/DD/YYYY');
    this.loadDefaultGamesFromDates(newSelectedDate, value);

    this.props.updateMobileState({
      startDate: newSelectedDate,
      value: value,
      page: 'home',
      showAllGames: showAllGames
    });

    this.setState({
      ...this.state,
      defaultGamesLoaded: false,
      displayAdditionalGames: false
    });
  };

  handleDateDisplay = () => {
    const { startDate, value } = this.props.mobile;

   // if (this.defaultGamesLoaded()) {
      let nowDate = new Date(startDate);
      let startDay = nowDate.getUTCDate();
      let startMonth = nowDate.getUTCMonth() + 1;

      let nextDate = new Date(addDays(nowDate, value));
      let endDay = nextDate.getUTCDate();
      let endMonth = nextDate.getUTCMonth() + 1;

      nowDate = format(nowDate, 'MM/DD/YYYY');
      nextDate = format(nextDate, 'MM/DD/YYYY');

      if (value === 7) {
        return (
          <div>
            {startMonth}/{startDay} - {endMonth}/{endDay}
          </div>
        );
      } else {
        return <div>{nowDate}</div>;
      }
    //}
  };

  handleMobileFilter = event => {
    const { userSeason, seasons } = this.props;

    let newFilterValue;
    switch (event.target.value) {
      case '7':
        newFilterValue = 7;
        break;
      case '1':
        newFilterValue = 1;
        break;
      default:
        newFilterValue = this.state.filter.value;
        break;
    }

    const date = this.state.filter.startDate === '' ? Date.now() : this.state.filter.startDate;
    const startDate = format(date, 'MM/DD/YYYY');
    let endDate = format(addDays(startDate, newFilterValue), 'MM/DD/YYYY');

    //Only allow end of range to be within the max set for the season
    if (!this.isAdmin()) {
      const maxDate = format(seasons[userSeason].maxScheduleDate, 'MM/DD/YYYY');
      endDate = (endDate > maxDate) ? maxDate : endDate;
    }

    this.props.filterGames(startDate, endDate, userSeason, '', '', '', this.state.showAllGames, false);

    const mobile = {
      startDate: date,
      value: newFilterValue,
      showAllGames: this.state.showAllGames,
      page: 'home'
    };
    this.props.updateMobileState(mobile);

    this.props.updateMobileState({...this.state.filter, value: newFilterValue});
    this.setState({ ...this.state, value: newFilterValue });
  };

  handleCheckboxChange = event => {
    const { checked } = event.target;
    const { userSeason, seasons } = this.props;
    const date = this.state.filter.startDate === '' ? Date.now() : this.state.filter.startDate;
    const startDate = format(date, 'MM/DD/YYYY');
    let endDate = format(addDays(startDate, this.state.filter.value), 'MM/DD/YYYY');

    //Only allow end of range to be within the max set for the season
    if (!this.isAdmin()) {
      const maxDate = format(seasons[userSeason].maxScheduleDate, 'MM/DD/YYYY');
      endDate = (endDate > maxDate) ? maxDate : endDate;
    }

    this.props.filterGames(startDate, endDate, userSeason, '', '', '', checked, false);

    const mobile = {
      startDate: date,
      value: this.state.filter.value,
      showAllGames: checked,
      page: 'home'
    };
    this.props.updateMobileState(mobile);
    this.setState({ ...this.state, showAllGames: checked });
  };

  loadDefaultGames = () => {
    const { startDate, value } = this.state.filter;
    const date = startDate === '' ? Date.now() : startDate;
    const newSelectedDate = format(date, 'MM/DD/YYYY');
    
    const endDate = format(addDays(newSelectedDate, value), 'MM/DD/YYYY');
    this.props.filterGames(newSelectedDate, endDate, this.areSeasonsLoaded() ? this.props.userSeason : '', '', '', '', this.state.showAllGames, false);

    this.setState({ ...this.state, additionalGamesLoaded: false, displayAdditionalGames: false });
  };

  updateDefaultGames = newUserSeason =>{
    const { seasons } = this.props;
    const { startDate, value } = this.state.filter;
    const date = startDate === '' ? Date.now() : startDate;
    const newSelectedDate = format(date, 'MM/DD/YYYY');
    let endDate = format(addDays(newSelectedDate, value), 'MM/DD/YYYY');

    //Only allow end of range to be within the max set for the season
    if (!this.isAdmin()) {
      const maxDate = format(seasons[newUserSeason].maxScheduleDate, 'MM/DD/YYYY');
      endDate = (endDate > maxDate) ? maxDate : endDate;
    }

    this.props.filterGames(newSelectedDate, endDate, newUserSeason, '', '', '', this.state.showAllGames, false);
    
    //this.setState({ ...this.state, additionalGamesLoaded: false, displayAdditionalGames: false, selectedSeason: newUserSeason });
    this.setState({ ...this.state, additionalGamesLoaded: false, displayAdditionalGames: false });
  }

  loadDefaultGamesFromDates = (dateToUse, dateRange) => {
    const { userSeason, seasons } = this.props;
    const newSelectedDate = format(dateToUse, 'MM/DD/YYYY');
    let endDate = format(addDays(newSelectedDate, dateRange), 'MM/DD/YYYY');

    //Only allow end of range to be within the max set for the season
    if (!this.isAdmin()) {
      const maxDate = format(seasons[userSeason].maxScheduleDate, 'MM/DD/YYYY');
      endDate = (endDate > maxDate) ? maxDate : endDate;
    }

    this.props.filterGames(newSelectedDate, endDate, this.areSeasonsLoaded() ? this.props.userSeason : '', '', '', '', this.state.showAllGames, false);
    
    this.setState({ ...this.state, additionalGamesLoaded: false, displayAdditionalGames: false });
  };

  checkForUmpire(object) {
    const maxUmps = object.umpAvailable !== null ? object.umpAvailable : 2;
    if (maxUmps <= object.umpsUsed) {
      return 'mobile-row-blue';
    } else if (object.umpsUsed > 0) {
      return 'mobile-row-yellow';
    } else {
      return 'mobile-row-red';
    }
  }

  renderRowDate(game) {
    const { memberId, teamsCoaching, teamsVolunteering } = this.props;

    let objectDate = new Date(format(game.startDate, 'MM/DD/YYYY'));
    let daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    let weekDay = daysOfWeek[objectDate.getUTCDay()];
    let numberDay = objectDate.getUTCDate();

    let isPlateUmpire = false;
    if (memberId === game.umpPlateId)
      isPlateUmpire = true;
    let isBaseUmpire = false;
    if (memberId === game.umpBase1Id || memberId === game.umpBase2Id || memberId === game.umpBase3Id)
      isBaseUmpire = true;
      
    let isGameCoach = false;
    teamsCoaching.forEach((team) => {
      if (game.homeTeamId === team.teamId || game.awayTeamId === team.teamId) isGameCoach = true;
    });

    let isTeamVolunteer = false;
    teamsVolunteering.forEach((team) => {
      if (game.homeTeamId === team.teamId || game.awayTeamId === team.teamId) isTeamVolunteer = true;
    });

    return (
      <Grid container spacing={8} direction= "row" alignItems="center">
        <Grid item xs={7} style={{paddingLeft: 8}}>
          <Typography variant="h4" align="center">
            {numberDay}
          </Typography>
          <Typography variant="body1" align="center">
            {weekDay}
          </Typography>
        </Grid>
        <Grid item xs={5} >
          {game.cancelled && <img src={cancelledGameIcon} height="24" width="auto" alt="Cancelled" />}
          {isGameCoach && <img src={coachCapIcon} height="24" width="auto" alt="Coach Cap" />}
          {isPlateUmpire && <img src={umpMaskIcon} height="26" width="auto" alt="Umpire Mask" />}
          {isBaseUmpire && <img src={umpCapIcon} height="20" width="auto" alt="Umpire Cap"  />}
          {isTeamVolunteer && <img src={cheerIcon} height="20" width="auto" alt="Cheer"  />}
        </Grid>
      </Grid>
    );
  }

  renderGame = (gameId, games) => {
    const { value, startDate } = this.state.filter;
    let startFilterDate = new Date(format(startDate, 'MM/DD/YYYY'));
    let endFilterDate = new Date(format(addDays(startFilterDate, value === 7 ? 8 : 1), 'MM/DD/YYYY'));

    let id = gameId;

    let gameStartDate = new Date(games[id].startDate);
    if (gameStartDate.getTime() < endFilterDate.getTime() && gameStartDate.getTime() >= startFilterDate.getTime()) {

      const game = games[gameId];
      return (
        <Grid container spacing={8} direction="row">
          <Grid item xs={3}>
            {this.renderRowDate(game)}
          </Grid>
          <Grid item xs={9}>
            <div className={this.checkForUmpire(game)} key={`upcomingGames-${id}`}>
              <div className="mobile-game-info-container" id={id}>
                <div className="sub-row">
                  <Link to={`/selected-game/${gameId}`}>
                    <h3>{`${format(game.startDate, 'h:mm a')} @ ${game.facilityName}`}</h3>
                    <h4>
                      <span>{`${game.divisionName}`}</span>
                      {`${game.homeTeamName} (H) vs ${game.awayTeamName} (A)`}
                    </h4>
                  </Link>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      );
    }
  };

  changeSelectedSeason = event =>{
    this.props.changeUserSeason(event.target.value);
  }

  render() {
    const {
      games,
      filteredGamesList,
      userSeason,
      seasons,
      seasonsList, 
    } = this.props;

    let gamesListToDisplay = null;
    if (this.filterGamesLoaded()) {
      gamesListToDisplay = filteredGamesList;
    }

    return (
      <div className="home-mobile-container">
        <div className="form-container-home-upcoming-games">
          <div className="section-heading">
            <div className="section-title">
              <h2 className="left">UPCOMING GAMES</h2>
              <label className="pt-label pt-inline">
                 Season:
                 <select
                    padding-left={2}
                   className="pt-input"
                   id="season"
                   value={userSeason}
                   onChange={this.changeSelectedSeason}
                 >
                   {seasonsList.map(seasonId => {
                     return (
                       <option key={seasonId} value={seasonId}>
                         {seasons[seasonId].name}
                       </option>
                     );
                   })}
                 </select>
              </label>
            </div>
            <div className="section-title">
                <label className="pt-label pt-inline checkbox-display-full-games">
                  All Games: { }
                  <input
                    type="checkbox"
                    value={this.state.filter.showAllGames}
                    onChange={this.handleCheckboxChange}
                    checked={this.state.filter.showAllGames}
                  />
                </label>
                <label className="pt-label pt-inline">
                  Select Filter: { }
                  <select onChange={this.handleMobileFilter} value={this.state.filter.value}>
                    {Object.values(this.state.filterType).map(type => {
                      return (
                        <option 
                          value={type.value}
                          key={type.text}
                        >
                          {type.text}
                        </option>
                      );
                    })}
                  </select>
                </label>
              </div>
            
            <div className="section-title">
              <button
                className="pt-button pt-minimal pt-icon-large pt-icon-chevron-left"
                onClick={this.handleSubtractDate}
              />
              <h2>{this.handleDateDisplay()}</h2>
              <button
                className="pt-button pt-minimal pt-icon-large pt-icon-chevron-right"
                onClick={this.handleAddDate}
              />
            </div>
          </div>
          <div className="mobile-games-container">
            {this.filterGamesLoaded() ? (
              <div>
                {gamesListToDisplay.length > 0 ? (
                  <div>
                    {gamesListToDisplay.map((id, index) => {
                      return <div key={games[id].id}>{this.renderGame(id, games)}</div>;
                    })}
                  </div>
                ) : (
                  <div className="mobile-empty-table"> No games during this period. </div>
                )}
              </div>
            ) : (
              <div className="mobile-empty-table"> Loading Games... </div>
            )}
          </div>
          {!this.state.displayAdditionalGames &&
          this.state.defaultGamesLoaded && 
          !this.state.showAllGames ? (
            <div className="load-additional-games-container">
              <a onClick={this.loadAdditionalGames}>Load More Games</a>
            </div>
          ) : (
            ''
          )}
        </div>
        {this.props.error !== null ? (
          <div>
            <ErrorPopup error={this.props.error} clearErrors={this.props.clearErrors} />
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
}

export default HomeMobile;



// WEBPACK FOOTER //
// ./src/components/HomeMobile.js